import { useState, useEffect } from 'react';
import axios from 'axios';

function UseAccessCodePage() {

  const [name, setName] = useState('');
  const [school, setSchool] = useState('');
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  // AUTO-READ CODE FROM URL
  useEffect(() => {

    const params =
      new URLSearchParams(window.location.search);

    const urlCode = params.get('code');

    if (urlCode) {

      const cleanCode =
        urlCode.trim().toUpperCase();

      setCode(cleanCode);
    }

  }, []);

  // VERIFY ACCESS CODE
  const verifyCode = async (inputCode) => {

    if (loading) return;

    const cleanCode =
      inputCode.trim().toUpperCase();

    if (!name.trim()) {
      setMessage('Please enter your full name.');
      return;
    }

    if (!school.trim()) {
      setMessage('Please enter your school.');
      return;
    }

    if (!cleanCode) {
      setMessage('Please enter your access code.');
      return;
    }

    setLoading(true);
    setMessage('');
    setSuccess(false);

    try {

      const res = await axios.post(
        `${API_URL}/api/use-access-code`,
        {
          code: cleanCode,
        }
      );

      if (res.data.success) {

        const usageCount =
          res.data.usageCount || 0;

        /*
         * Do NOT clear all localStorage.
         * Only remove old TickQuiz session data.
         */
        localStorage.removeItem('quizUser');
        localStorage.removeItem('quizAccessGranted');
        localStorage.removeItem('quizUsageCount');
        localStorage.removeItem('quizAccessCode');
        localStorage.removeItem('quizProgress');

        // SAVE STUDENT
        localStorage.setItem(
          'quizUser',
          JSON.stringify({
            name: name.trim(),
            school: school.trim(),
            code: cleanCode,
          })
        );

        // GRANT ACCESS
        localStorage.setItem(
          'quizAccessGranted',
          'true'
        );

        // SAVE USAGE INFORMATION
        localStorage.setItem(
          'quizUsageCount',
          String(usageCount)
        );

        // SAVE ACCESS CODE
        localStorage.setItem(
          'quizAccessCode',
          cleanCode
        );

        setSuccess(true);

        setMessage(
          'Access granted! Redirecting...'
        );

        /*
         * Student can continue using TickQuiz
         * until they log out.
         */
        setTimeout(() => {

          window.location.href = '/start';

        }, 800);

      } else {

        setMessage(
          res.data.message ||
          'Invalid or expired access code.'
        );

      }

    } catch (err) {

      console.error(
        'ACCESS CODE ERROR:',
        err
      );

      setMessage(
        err.response?.data?.message ||
        'Something went wrong. Please try again.'
      );

    } finally {

      setLoading(false);

    }
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    verifyCode(code);

  };

  return (

    <div className="
      min-h-screen
      flex
      items-center
      justify-center
      bg-gray-100
      px-2
    ">

      <div className="
        bg-white
        shadow-md
        rounded-lg
        p-4
        w-full
        max-w-xs
      ">

        <h2 className="
          text-lg
          font-bold
          text-center
          mb-3
        ">
          Enter Details
        </h2>

        <form
          onSubmit={handleSubmit}
          className="space-y-2"
        >

          {/* FULL NAME */}
          <input
            type="text"
            value={name}
            onChange={(e) =>
              setName(e.target.value)
            }
            placeholder="Full Name"
            className="
              w-full
              px-3
              py-2
              text-sm
              border
              rounded-md
            "
          />

          {/* SCHOOL */}
          <input
            type="text"
            value={school}
            onChange={(e) =>
              setSchool(e.target.value)
            }
            placeholder="School Name"
            className="
              w-full
              px-3
              py-2
              text-sm
              border
              rounded-md
            "
          />

          {/* ACCESS CODE */}
          <input
            type="text"
            value={code}
            onChange={(e) =>
              setCode(
                e.target.value.toUpperCase()
              )
            }
            placeholder="Enter Access Code"
            className="
              w-full
              px-3
              py-2
              text-sm
              border
              rounded-md
            "
          />

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className={`
              w-full
              py-2
              text-sm
              rounded-md
              text-white
              font-semibold
              ${
                loading
                  ? 'bg-gray-400'
                  : 'bg-green-600 hover:bg-green-700'
              }
            `}
          >

            {loading
              ? 'Verifying...'
              : 'Continue'}

          </button>

        </form>

        {/* MESSAGE */}
        {message && (

          <p
            className={`
              mt-3
              text-center
              text-xs
              ${
                success
                  ? 'text-green-600'
                  : 'text-red-600'
              }
            `}
          >

            {message}

          </p>

        )}

      </div>

    </div>
  );
}

export default UseAccessCodePage;